export enum AddressEnum {
  Dutch = 'AddressDutch',
  International = 'AddressInternational',
}

interface Address {
  type: AddressEnum;
  street: string;
  zipCode: string;
  city: string;
  number?: string;
  suffix?: string;
  country: string;
}

export default Address;

export const AddressDefaults = {
  type: 'AddressDutch',
  street: '',
  zipCode: '',
  city: '',
  number: '',
  suffix: '',
  country: '',
};
